import Loadable from "components/Loadable";
import AuthGuard from "guards/AuthGuard";
import NoAuthGuard from "guards/NoAuthGuard";
import ForgotPasswordPage from "pages/AuthPage/ForgotPasswordPage/ForgotPasswordPage";
import ReportRevisionPage from "pages/ReportRevisionPage/ReportRevisionPage";
import RevisionsPage from "pages/RevisionsPage/RevisionsPage";
import { lazy } from "react";
import { Navigate, RouteObject, useRoutes } from "react-router-dom";
const AdminLayout = Loadable(
  lazy(() => import("layouts/AdminLayout/AdminLayout"))
);
const AuthLayout = Loadable(
  lazy(() => import("layouts/AuthLayout/AuthLayout"))
);
const PartnersPage = Loadable(
  lazy(() => import("pages/PartnersPage/PartnersPage"))
);
const PartnerPage = Loadable(
  lazy(() => import("pages/PartnerPage/PartnerPage"))
);
const ReportsPage = Loadable(
  lazy(() => import("pages/ReportsPage/ReportsPage"))
);
const LoginPage = Loadable(
  lazy(() => import("pages/AuthPage/LoginPage/LoginPage"))
);
const NotFoundPage = Loadable(
  lazy(() => import("pages/NotFoundPage/NotFoundPage"))
);

const ReportPage = Loadable(lazy(() => import("pages/ReportPage/ReportPage")));

const ReportDetailPage = Loadable(
  lazy(() => import("pages/ReportDetailPage/ReportDetailPage"))
);

const PartnerDetailPage = Loadable(
  lazy(() => import("pages/PartnerDetailPage/PartnerDetailPage"))
);

const ChangePasswordPage = Loadable(
  lazy(() => import("pages/ChangePasswordPage/ChangePasswordPage"))
);

const RegisterPage = Loadable(
  lazy(() => import("pages/AuthPage/RegisterPage/RegisterPage"))
);

export default function Router() {
  const routes: RouteObject[] = [
    {
      path: "/auth",
      element: (
        <NoAuthGuard>
          <AuthLayout />
        </NoAuthGuard>
      ),
      children: [
        {
          path: "/auth/login",
          element: <LoginPage />,
        },
        {
          path: "/auth/forgot-password",
          element: <ForgotPasswordPage />,
        },
        {
          path: "/auth/register",
          element: <RegisterPage />,
        },
      ],
    },
    {
      path: "/",
      element: (
        <AuthGuard>
          <AdminLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: "/profile/change-password",
          element: <ChangePasswordPage />,
        },
        {
          path: "/reports/add",
          element: <ReportPage />,
        },
        {
          path: "/reports",
          element: <ReportsPage />,
        },
        {
          path: "/reports/:id/edit",
          element: <ReportPage />,
        },
        {
          path: "/reports/:id/detail",
          element: <ReportDetailPage />,
        },
        {
          path: "/reports/:id/revisions",
          element: <RevisionsPage />,
        },
        {
          path: "/revisions/:id",
          element: <ReportRevisionPage />,
        },
        {
          path: "/partners",
          element: <PartnersPage />,
        },
        {
          path: "/partners/add",
          element: <PartnerPage />,
        },
        {
          path: "/partners/:id/edit",
          element: <PartnerPage />,
        },
        {
          path: "/partners/:id/detail",
          element: <PartnerDetailPage />,
        },
        {
          path: "/",
          index: true,
          element: <Navigate to="/partners" replace />,
        },
      ],
    },

    {
      path: "*",
      element: <NotFoundPage />,
    },
  ];

  const routing = useRoutes(routes);

  return routing;
}
